// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"646":"35530d94","754":"aea45575","787":"56037a0f"}[chunkId] + ".chunk.js";
};